// Route constants
export const GLOBAL_TOUR_ROUTE = '/*';

// Style constants
export const TOUR_FONT_FAMILY =
  'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif';
export const TOUR_PRIMARY_COLOR = '#2185d0';
export const TOUR_LINK_COLOR = '#4183c4';
export const TOUR_TEXT_COLOR = 'rgba(0,0,0,.87)';
// react-joyride renders beacons/overlays at this value and tooltips at
// this value + 100; the whole stack must stay below Semantic UI's dimmer
// (1000) and modal (1001) so the tour doesn't float above open modals
export const TOUR_Z_INDEX = 899;

// Button styles
export const TOUR_BUTTON_BORDER_RADIUS = '.28571429rem';
export const TOUR_BUTTON_PADDING = '0.75rem 1.5rem';

// Tour style configuration for Joyride
export const TOUR_STYLE_OPTIONS = {
  options: {
    zIndex: TOUR_Z_INDEX,
    textColor: TOUR_TEXT_COLOR,
    fontFamily: TOUR_FONT_FAMILY,
    primaryColor: TOUR_PRIMARY_COLOR,
  },
  buttonNext: {
    backgroundColor: TOUR_PRIMARY_COLOR,
    fontFamily: TOUR_FONT_FAMILY,
    borderRadius: TOUR_BUTTON_BORDER_RADIUS,
    fontSize: '1rem',
    fontWeight: 700,
    outline: 'none',
    padding: TOUR_BUTTON_PADDING,
  },
  buttonBack: {
    fontFamily: TOUR_FONT_FAMILY,
    color: TOUR_LINK_COLOR,
    fontSize: '1.125rem',
    fontWeight: 700,
    outline: 'none',
  },
  buttonSkip: {
    fontFamily: TOUR_FONT_FAMILY,
    fontWeight: 700,
    fontSize: '1.25rem',
  },
  beacon: {
    top: '0.345rem',
    outline: 'none',
  },
};

// UI text constants
export const TOUR_LAST_BUTTON_TEXT = 'Got it!';
export const TOUR_BUTTON_LABEL = 'Learn more about this view';

// Default tour properties
export const DEFAULT_TOUR_PROPS = {
  isDisabled: true,
  showIntro: true,
};

// Route processing constants
export const ROUTE_CONTEXT_SEGMENTS_TO_REMOVE = 2;
